// extracted by mini-css-extract-plugin
export default {"superWrapper":"Feedback_superWrapper__lft1P","wrapper1":"Feedback_wrapper1__DrECs","feedback":"Feedback_feedback__G7aFx"};